// トップページの「特集コレクション」の見出しの高さを揃える
(function($){
  function applyBottomTitleHeight(){
    // 下段タイトルのみを対象
    var $targets = $('li.grid__item .card__content .card__information > h3.card__heading.h5');

    if($targets.length){
      $targets.css('display','block'); // 念のため display:block
      $targets.matchHeight({ byRow: true });
      console.log('Card bottom titles matchHeight applied to', $targets.length, 'elements');
    }
  }
  // ページロード後
  $(window).on('load', applyBottomTitleHeight);
  // Shopifyセクションロード後
  document.addEventListener('shopify:section:load', applyBottomTitleHeight);

});

// (function($){
//   var $setElem = $('.switch'),
//       pcName = 'pc_',
//       spName = 'sp_',
//       replaceWidth = 767;

//   $setElem.each(function(){
//     var $this = $(this);
//     function imgSize(){
//       var windowWidth = window.innerWidth;
//       if(windowWidth >= replaceWidth) {
//         $this.attr('src',$this.attr('src').replace(spName,pcName)).css({visibility:'visible'});
//       } else {
//         $this.attr('src',$this.attr('src').replace(pcName,spName)).css({visibility:'visible'});
//       }
//     }
//     $(window).resize(imgSize);
//     imgSize();
//   });
// })(jQuery);

$(function(){
  var $setElem = $('.switch'),
      pcName = 'pc_',
      spName = 'sp_',
      replaceWidth = 768;

  function imgSize(){
    var windowWidth = window.innerWidth;

    $setElem.each(function(){
      var $this = $(this);
      var src = $this.attr('src');

      if(!src) return;

      if(windowWidth >= replaceWidth) {
        if(src.indexOf(spName) !== -1){
          $this.attr('src', src.replace(spName, pcName));
        }
      } else {
        if(src.indexOf(pcName) !== -1){
          $this.attr('src', src.replace(pcName, spName));
        }
      }
    });
  }

  $(window).on('resize', imgSize);
  imgSize();
});

// ページトップ
(function($){
  var pagetop = $('.pagetop');
  $(window).on('scroll', function(){
    if ($(this).scrollTop() > 100) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
  pagetop.click(function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
})(jQuery);

// スムーズスクロール
(function($){
  $('a').click(function(e){
    var href = $(this).attr('href');
    if(href && href.search(/^#/) >= 0){
      e.preventDefault();
      var target = $(href == "#" || href == "" ? 'html' : href);
      $("html, body").animate({ scrollTop: target.offset().top }, 400);
      return false;
    }
  });
})(jQuery);

// SP横スクロール
// (function($){
//   new ScrollHint('.js-scrollable', {
//     scrollHintIconAppendClass: 'scroll-hint-icon-white',
//     suggestiveShadow: true,
//     i18n: { scrollable: 'スクロールできます' }
//   });
// })(jQuery);

(function($) {
  // タイトルクリックでポップアップ表示
  $(".v-blog-yt__title").on("click", function(e) {
    e.preventDefault();
    var popupId = $(this).data("article-id");
    var $popup = $("#" + popupId);
    if ($popup.length) {
      $popup.addClass("show");
      $("body").addClass("popup-open"); // 背景固定
    }
  });

  // 閉じるボタンで非表示
  $(".yt-popup__close").on("click", function() {
    $(this).closest(".yt-popup").removeClass("show");
    $("body").removeClass("popup-open"); // 背景固定解除
  });

  // 背景クリックで非表示
  $(".yt-popup").on("click", function(e) {
    if (e.target === this) {
      $(this).removeClass("show");
      $("body").removeClass("popup-open"); // 背景固定解除
    }
  });

  // 商品詳細　アコーディオン
  $('.v-product_acc-wrap').on('click', function() {
    $(this).children('.v-product_head').toggleClass('open');
    $(this).children('.v-product_acc').slideToggle(500);
  });
})(jQuery);

